import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Hook to make the query client instance available globally
 * This is used by the useProjectMetadata hook to access the query cache
 */
export function useQueryClientInstance() {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Make the query client available globally
    // This is a workaround to access the query client from outside React components
    window.__QUERY_CLIENT__ = queryClient;
  }, [queryClient]);
}

// Add TypeScript declaration for the global window object
declare global {
  interface Window {
    __QUERY_CLIENT__: any;
  }
}
